import {Grid2} from "@mui/material";
import isPast from "date-fns/isPast";
import isSameDay from "date-fns/isSameDay";
import React, {useMemo} from "react";

import {DayColumnHeader} from "./styled-components";
import { getShiftEffectiveStartDay } from "./utils";

const MemoizedDayColumnHeader = (({ day, offsetStartTime = 0, ...props }: { day: Date, offsetStartTime?: number} & React.ComponentProps<typeof Grid2>) => {
    const styles = useMemo(
        () => {
          const effectiveToday = getShiftEffectiveStartDay(new Date(), offsetStartTime); // Adjust current date with offset
          return {
            backgroundColor: isSameDay(day, effectiveToday)
              ? "#2F4D8B29"
              : isPast(day)
                ? "rgba(0,0,0,0.02)"
                : "#fff",
          }
        },
        [day, offsetStartTime]
    );

    return <DayColumnHeader style={styles} {...props}/>;
});

export default React.memo(MemoizedDayColumnHeader);